import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PELSeleccionToolbar from '../containers/PELSeleccionToolbar';
import { Flex } from '../../shared/components';
import PELSeleccionLentesList from '../containers/PELSeleccionLentesList';
import PELFooter from '../containers/PELFooter';
import { sendCloseMessageGW1 } from '../../../helpers/GW1sendMessage.helper';


function PELSeleccionarPage({
  history, modo, showPelFooterTopBorder,
  onSeleccionarLente, onClose, onGoBack,
  style, showPelFooter, pedirSuplementos, viene_de
}) {
  return (
    <Flex flexDirection="column" bg="white" color="#495176" overflow="hidden" {...style}>
      <PELSeleccionToolbar />
      <PELSeleccionLentesList modo={modo} hideLastBorder={showPelFooterTopBorder} />
      {showPelFooter && modo === 'seleccion' && <PELFooter pedirSuplementos={pedirSuplementos} showTopBorder={showPelFooterTopBorder} history={history} onSeleccionarLente={onSeleccionarLente} onClose={onClose} onGoBack={onGoBack} viene_de ={viene_de} />}
    </Flex>
  );
}
const mapStateToProps = ({ pel }) => ({
  modo: pel.modo,
  viene_de: pel.viene_de,

});
export default connect(
  mapStateToProps,
)(PELSeleccionarPage);

PELSeleccionarPage.propTypes = {
  history: PropTypes.shape({}),
  modo: PropTypes.string,
  style: PropTypes.shape({}),
  onSeleccionarLente: PropTypes.func,
  onGoBack: PropTypes.func,
  onClose: PropTypes.func,
  showPelFooter: PropTypes.bool,
  pedirSuplementos: PropTypes.bool,
  showPelFooterTopBorder: PropTypes.bool,
};
PELSeleccionarPage.defaultProps = {
  modo: 'consulta',
  showPelFooter: true,
  showPelFooterTopBorder: false,
  pedirSuplementos: false,
  style: { height: '100%' },
  onSeleccionarLente: sendCloseMessageGW1,
  onClose: () => sendCloseMessageGW1(),
  onGoBack: null,
  history: undefined,
};
